import {Signal} from "signal-polyfill";

/** @type {Signal.State<String|null>} */
export const themeSignal = new Signal.State(null);